// @flow
import * as React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { TouchableOpacity } from 'react-native-gesture-handler';
import { Icon } from '../../../../components/common';
import I18n from '../../../../lib/i18n';
import theme from '../../../../theme-config';
import WizzeeLog from '../../../../lib/wizzeeLog';

const styles = StyleSheet.create({
  parent: {
    marginBottom: 15,
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginRight: 20,
    marginLeft: 20,
    marginTop: 10,
    padding: 5,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: theme.secondaryColor,
  },
  leftContainer: { flex: 1.5, flexDirection: 'column' },
  centerContainer: {
    flex: 5,
    flexDirection: 'column',
    marginLeft: 10,
  },
  itemIcon: {
    alignSelf: 'center',
  },
  itemCross: {
    alignSelf: 'flex-start',
  },
  title: {
    marginRight: 20,
    marginLeft: 20,
    marginTop: 20,
    paddingTop: 0,
    paddingBottom: 0,
    fontSize: 15,
    fontWeight: '600',
    color: theme.secondaryColor,
  },
  voucherLabel: {
    flex: 0.8,
    color: theme.primaryColor,
    fontSize: 18,
    fontWeight: '600',
  },
  voucherShortDescription: {
    flex: 1,
    color: theme.secondaryColor,
    fontSize: 13,
  },
});

class SelectedVoucherItem extends React.Component<Props> {
  render() {
    const onRemoveSelectedVoucher = () => {
      WizzeeLog.log(`Removed selected voucher`);
      this.props.setCurrentVoucherDetails(null);
    };

    return (
      <View style={styles.parent}>
        <Text style={styles.title}>{I18n.t('selectedVoucher.title')}</Text>
        <TouchableOpacity onPress={this.props.onPressSelectedVoucher}>
          <View style={styles.container}>
            <View style={styles.leftContainer}>
              <Icon
                style={styles.itemIcon}
                size={60}
                resizeMode="contain"
                name={I18n.t(
                  `productOffering.PVOUCHER.productSpecification.characteristics.labelCode.${this.props.selectedVoucher.labelCode}.picto`
                )}
                color={theme.secondaryColor}
              />
            </View>
            <View style={styles.centerContainer}>
              <Text style={styles.voucherLabel}>
                {I18n.t(
                  `productOffering.PVOUCHER.productSpecification.characteristics.labelCode.${this.props.selectedVoucher.labelCode}.label`
                )}
              </Text>
              <Text style={styles.voucherShortDescription}>
                {I18n.t(
                  `productOffering.PVOUCHER.productSpecification.characteristics.labelCode.${this.props.selectedVoucher.labelCode}.shortDesc`
                )}
              </Text>
            </View>
            <TouchableOpacity style={{ padding: 10 }} onPress={onRemoveSelectedVoucher}>
              <Icon name={'cross'} size={15} color={theme.secondaryColor} />
            </TouchableOpacity>
          </View>
        </TouchableOpacity>
      </View>
    );
  }
}

type Props = {
  selectedVoucher: Object,
  setCurrentVoucherDetails: Function,
  onPressSelectedVoucher: Function,
};

export default SelectedVoucherItem;
